<div class="statistic-leaders">
  <div class="row" *ngFor="let group of groups">
    <div class="leader-title">{{ group.title }}</div>
    <div class="param-tabs">
      <a
        *ngFor="let param of group.params"
        href="javascript:;"
        class="active"
        [ngClass]="{active: selectedParams[group.id].id === param.id}"
        (click)="selectedParams[group.id] = param"
      >{{ param.title }}</a>
    </div>
    <mtg-statistic-leaders
      [statistic]="filteredStatistic"
      [param]="selectedParams[group.id]"
      [seasonId]="seasonId"
    ></mtg-statistic-leaders>
  </div>
</div>
